import {Component, Input, OnInit} from '@angular/core'

@Component({
  selector: 'dmmp-detail-program-desc-simplificada',
  templateUrl: './detail-program-desc-simplificada.component.html'
})
export class DetailProgramDescSimplificadaComponent implements OnInit {
  @Input() identifier
  @Input() data
  active = 0

  constructor() {
  }

  ngOnInit() {}
}
